module.exports = __webpack_public_path__ + "static/media/intivinelogo_words.737b0e6c.jpg";